import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers-pro';
import React from 'react';

import { LegacyMuiTextField } from '~/legacy-components/LegacyForms/components/LegacyMuiTextField';
import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

export type DatePickerPropsFragment<TInputDate, TDate> = Omit<
  DatePickerProps<TInputDate, TDate>,
  'renderInput'
>;

type Props<TInputDate, TDate> = DatePickerPropsFragment<TInputDate, TDate> & {
  error?: boolean;
  id?: string;
  sx?: SxProps<Theme>;
};

export const LegacyDateInput = <TInputDate, TDate>(
  props: Props<TInputDate, TDate>,
) => {
  const { error, id, sx, ...rest } = props;
  const sxStyles = useSxStyles();

  const pickerProps: DatePickerPropsFragment<TInputDate, TDate> = {
    ...rest,
  };

  return (
    <DatePicker
      {...pickerProps}
      renderInput={(params) => (
        <LegacyMuiTextField
          {...params}
          error={!!error || params.error}
          id={id}
          sx={mergeSxProps(sxStyles.dateInput, params.sx, sx)}
        />
      )}
    />
  );
};
